var en = {
  "Add Quantity Breaks to your product page": "Add Quantity Breaks to your product page",
  "Add Upsell.com to your ": "Add Upsell.com to your ",
  "All time": "All time",
  "and select": "and select",
  "button": "button",
  "Cart drawer page": "Cart drawer page",
  "Cart page": "Cart page",
  "Check status": "Check status",
  "Checkout page": "Checkout page",
  "Click": "Click",
  "Click on": "Click on",
  "Click the": "Click the",
  "Custom slot": "Custom slot",
  "Custom slots": "Custom slots",
  "Custom Slots": "Custom Slots",
  "contact support.": "contact support.",
  "from the right sidebar": "from the right sidebar",
  "Go to App Embeds": "Go to App Embeds",
  "Go to your Cart drawer page": "Go to your Cart drawer page",
  "Go to your Cart page": "Go to your Cart page",
  "Go to your Checkout page": "Go to your Checkout page",
  "Go to your Order status page": "Go to your Order status page",
  "Go to your Post purchase page": "Go to your Post purchase page",
  "Go to your Product page": "Go to your Product page",
  "Go to your Thank you page": "Go to your Thank you page",
  "items": "items",
  "in the left sidebar": "in the left sidebar",
  "Last 12 months": "Last 12 months",
  "Last 30 days": "Last 30 days",
  "Last 365 days": "Last 365 days",
  "Last 7 days": "Last 7 days",
  "Last 90 days": "Last 90 days",
  "Last month": "Last month",
  "Last year": "Last year",
  "Make sure": "Make sure",
  "Need assistance? Contact our support team for help.": "Need assistance? Contact our support team for help.",
  "Order status page": "Order status page",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Our app is currently undergoing a bit of magic to enhance your experience.",
  "Post purchase page": "Post purchase page",
  "Product page": "Product page",
  "Save": "Save",
  "Scroll to the bottom and select": "Scroll to the bottom and select",
  "Select": "Select",
  "Success. Please continue.": "Success. Please continue.",
  "Thank you page": "Thank you page",
  "The Upsell.com team.": "The Upsell.com team.",
  "The Upsell.com widget is not placed on ": "The Upsell.com widget is not placed on ",
  ". Please follow the steps above or ": ". Please follow the steps above or ",
  "Today": "Today",
  "toggle is on": "toggle is on",
  "Total": "Total",
  "under": "under",
  "We apologize for any inconvenience caused,": "We apologize for any inconvenience caused,",
  "We apologize for any inconvenience caused.": "We apologize for any inconvenience caused.",
  "We'll be done in a few minutes!": "We'll be done in a few minutes!",
  "We're improving our services!": "We're improving our services!",
  "Widget already added": "Widget already added",
  "Yesterday": "Yesterday",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "You enabled the widget in your online store but didn't save it in the Upsell editor",
  "You placed the widget on the ": "You placed the widget on the ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", but you didn't save it in Shopify editor. Please go back to ",
  " and save the changes.": " and save the changes."
};

export { en as default };
//# sourceMappingURL=en.json.js.map
